import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnjoyingAppDialogComponent } from '@app-modules/feature/my-referral/enjoying-app-dialog/enjoying-app-dialog.component';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ExamService } from '@app-services/test/exam.service';
import { LocalStorageService } from 'ngx-webstorage';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { Router } from '@angular/router';
@Component({
  selector: 'app-rating-experience-dialog',
  templateUrl: './rating-experience-dialog.component.html',
  styleUrls: ['./rating-experience-dialog.component.css']
})
export class RatingExperienceDialogComponent implements OnInit {

  overallRatingForm: FormGroup;
  isBadEmoji: boolean;
  isOKEmoji: boolean;
  isGreatEmoji: boolean;
  questionText: string;
  option: string = 'EASY' || 'Too long';
  experienceFeedback:number;
  userPositiveLoginDetailsId:any;
  constructor(private formBuilder: FormBuilder,private dialogRef: MatDialogRef<RatingExperienceDialogComponent>, private storage: LocalStorageService, private examService: ExamService,private _inviteNdEarn:InviteEarnService,public dialog: MatDialog,private _router:Router,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log('dialog data', this.data);
    this.createOverallRatingForm();
    this.loadRatingTextsBasedOnEmoji(this.data.emojiValue);
    // this.examInfo = this.examService.getPresentExamInfo();
    // this.metaName = this.examInfo?.isLCAssignment ? "assignment": "test";
  }

  createOverallRatingForm(): void {
    this.overallRatingForm = this.formBuilder.group({
      additionalComments: [''],
      level1Rating: [''],
      emojiNum: this.data.emojiNum,
      level2Rating: ['']
    });
  }

  loadRatingTextsBasedOnEmoji(emojiValue): any {
    if(emojiValue == 'BAD'){
      this.isBadEmoji = true
      this.isOKEmoji = false
      this.isGreatEmoji = false
      this.questionText = 'What went wrong?'
      this.overallRatingForm.get('emojiNum').setValue(1)
    } else if(emojiValue == 'OK'){
      this.isBadEmoji = false
      this.isOKEmoji = true
      this.isGreatEmoji = false
      this.questionText = 'What needs to be improved?'
      this.overallRatingForm.get('emojiNum').setValue(2)

    } else if(emojiValue == 'GREAT'){
      this.isBadEmoji = false
      this.isOKEmoji = false
      this.isGreatEmoji = true
      this.questionText = 'What went well?'
      this.overallRatingForm.get('emojiNum').setValue(3);
      this.experienceFeedback=5;
    }
  }
  
  setLevel2Rating(rating2): any {
    this.overallRatingForm.get('level2Rating').setValue(rating2)
    switch (rating2) {
      case 'EASY': this.option = 'EASY'; break;
      case 'FUN': this.option = 'FUN'; break;
      case 'AWESOME': this.option = 'AWESOME'; break;
      case 'Too long': this.option = 'Too long'; break;
      case 'Too Fast': this.option = 'Too Fast'; break;
      case 'Too Short': this.option = 'Too Short'; break;
      case 'Incorrect concept': this.option = 'Incorrect concept'; break;
      case 'Wrong images': this.option = 'Wrong images'; break;
      case 'Confusing': this.option = 'Confusing'; break;
      default:
        break;
    }
  }
  sendFeedbackData(){
    let currentLogin=JSON.parse(localStorage.getItem('loginCount'));
    let userId=JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    let prodctId=2;
  
    this._inviteNdEarn.sendFeedbackData(currentLogin,prodctId,this.experienceFeedback,userId.userId).subscribe({next:(e)=>{
      this.userPositiveLoginDetailsId=e['userPositiveLoginDetailsId'];
      if(e['positiveLoginCount']==5 ||e['remindMeLaterCount']==1){
        this.enjoyAppInvite();
      }
    },error:(err)=>{console.error(err);
    }})
  }
  enjoyAppInvite() {
    const config: MatDialogConfig = {
      panelClass: ['REF-enjoyapp-dialog', 'UNFAPP-mweb-btmstiky-modal'],
      width:'250',           
      data: { },
    };
    const dialogRef = this.dialog.open(EnjoyingAppDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      console.log(value);
      if(value?.data){
        console.log('Shared!');
        this._router.navigateByUrl('/dashboard/referral/')
      }else{
        console.log('not shared!');
        //? calling reminder api
        this._inviteNdEarn.remindMeLaterPopup(this.userPositiveLoginDetailsId);
      }
    });
  }
  onConfirmClick(): void {
    if(this.experienceFeedback==5){
      this.sendFeedbackData();
    }
    this.overallRatingForm.get('level1Rating').setValue(this.data.emojiValue)
    if (this.data) {
      this.dialogRef.close(this.overallRatingForm.value);
    } else {
    }
  }

  onNoClick(): any{
    this.overallRatingForm.get('level1Rating').setValue(this.data.emojiValue)
    this.dialogRef.close(this.overallRatingForm.value)
  }

}
